/** Snooze sheet — "not now" with a date. Snooze is founder-only, reversible. */

import { SNOOZE_SENTINEL, snoozeDate } from "../lib/questions";

export function SnoozeSheet({
  onPick,
  onClose,
}: {
  onPick: (until: string) => void;
  onClose: () => void;
}) {
  const options: [string, string][] = [
    ["3 days", snoozeDate(3)],
    ["1 week", snoozeDate(7)],
    ["1 month", snoozeDate(30)],
    ["Until I decide", SNOOZE_SENTINEL],
  ];
  return (
    <div className="fixed inset-0 z-40 flex items-end bg-ink-950/60" onClick={onClose}>
      <div
        className="card w-full rounded-b-none p-4 pb-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between">
          <span className="text-sm font-medium text-ink-200">Snooze</span>
          <button className="btn-ghost px-3 py-1.5 text-xs" onClick={onClose}>
            Cancel
          </button>
        </div>
        <p className="mb-3 text-xs text-ink-500">
          The question leaves today's deck and comes back on its own — nothing is
          decided.
        </p>
        <div className="space-y-2">
          {options.map(([label, until]) => (
            <button
              key={label}
              onClick={() => onPick(until)}
              className="w-full rounded-xl border border-ink-800 p-3 text-left text-sm text-ink-200 transition-colors hover:bg-ink-850"
            >
              {label}
              <span className="ml-2 text-xs text-ink-500">until {until}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
